export default __webpack_public_path__ + "static/media/idea-napkin-template.6402dfe6.pptx";